import Authentication from "./authentication.vue";
import App from "./app.vue";
import AddressDetails from "./address-details.vue";
import AddressForm from "./address-form.vue";
import LocalAttrs from "./local_attrs.vue";
import LocalAttr from "./local_attr.vue";
import GlobalAttrs from "./global_attrs.vue";
import AddressValidationValidators from "./address_validation_validators.vue";
import AddressValidationFilters from "./address_validation_filters.vue";

import OrderChannelIndex from "./order_channels/index.vue";
import OrderChannelFilters from "./order_channels/filters.vue";

import CarrierIndex from "./carriers/index.vue";

import ImpersonateButton from "./customers/impersonate_button.vue";

import OrderChannelTypeIndex from "./order_channel_types/index.vue";
import OrderChannelTypeCreate from "./order_channel_types/create.vue";
import OrderChannelTypeEdit from "./order_channel_types/edit.vue";
import OrderChannelTypeForm from "./order_channel_types/form.vue";

import OrganizationIndex from "./organizations/index.vue";
import OrganizationEdit from "./organizations/edit.vue";
import OrganizationCreate from "./organizations/create.vue";
import OrganizationForm from "./organizations/form.vue";

import CarrierTypeIndex from "./carrier_types/index.vue";
import CarrierTypeCreate from "./carrier_types/create.vue";
import CarrierTypeEdit from "./carrier_types/edit.vue";
import CarrierTypeForm from "./carrier_types/form.vue";

import Plans from "./plans/index.vue";
import PlansFeaturesTable from "./plans/features-table.vue";
import Plan from "./plans/form.vue";

import Products from "./products/index.vue";
import Product from "./products/form.vue";

import PaymentTerms from "./payment_terms/index.vue";

import CustomerIndex from "./customers/index.vue";
import CustomerCreate from "./customers/create.vue";
import CustomerShow from "./customers/show.vue";
import CustomerShowCustomerQuoteQuicklink from "./customers/show/customer-quote-quicklink.vue";
import CustomerShowCustomerAgentsCard from './customers/show/cards/customer/customer-info-agents-card.vue';
import CustomerShowCustomerInfoSummaryCard from './customers/show/cards/customer/customer-info-summary-card.vue';
import CustomerShowCustomerTabPayments from './customers/show/customer-tab-payments.vue';
import CustomerShowCustomerInfoCard from './customers/show/cards/customer/customer-info-card.vue';
import CustomerShowCustomerInfoAdminCard from './customers/show/cards/customer/customer-info-admin-card.vue';
import CustomerShowCustomerInfoBillingCard from './customers/show/cards/customer/customer-info-billing-card.vue';
import CustomerShowCustomerInfoOrganizationCard from './customers/show/cards/customer/customer-info-organization-card.vue';
import CustomerShowCustomerInfoArchiveCard from './customers/show/cards/customer/customer-info-archive-card.vue';
import CustomerShowDiscountInfoCard from './customers/show/cards/discounts/discount-info-card.vue';
import CustomerShowCustomerTab from './customers/show/customer-tab.vue';
import CustomerShowCustomerHeaderTab from './customers/show/customer-header-tab.vue';
import CustomerShowCustomerHeaderRouting from './customers/show/customer-header-routing.vue';
import CustomerShowCustomerInfoNotesCard from './customers/show/cards/customer/customer-info-notes-card.vue';
import CustomerShowCustomerInfoInstallationNoteCard from './customers/show/cards/customer/customer-info-installation-note-card.vue';
import CustomerForm from "./customers/form.vue";
import CustomerEdit from "./customers/edit.vue";
import CustomerReset from "./customers/reset.vue";
import CustomerImpersonate from "./customers/impersonate.vue";
import CustomerFilters from "./customers/filters.vue";
import CustomerFiltersWhiteLabel from "./customers/filters-whitelabel.vue";
import CustomerEvents from "./customers/events.vue";
import CustomerAgentForm from "./customers/agent/form.vue";
import CustomerVatStatus from "./customers/vat_status.vue";
import CustomerShipmentUsage from "./customers/shipment_usage.vue";
import CustomerProjectedUsage from "./customers/projected_usage.vue";
import CustomerPlans from "./customers/plans.vue";
import CustomerChangeLogs from "./customers/change_logs.vue";
import CustomerPurchases from "./customers/purchases.vue";
import CustomerNewPurchaseForm from "./customers/new_purchase_form.vue";
import CustomerStaffAccesses from "./customers/staff_accesses.vue";
import CustomerStaffAccessForm from "./customers/staff_access_form.vue";
import CustomerStaffAccessCompleteModal from "./customers/staff_access_complete_modal.vue";
import CustomerCreationForm from "./customers/creation/form.vue";
import CustomerCreationCompany from "./customers/creation/company.vue";
import CustomerCreationVideo from "./customers/creation/video.vue";
import CustomerCreationIntegrations from "./customers/creation/integrations.vue";
import CustomerCreationQuote from "./customers/creation/quote.vue";
import CustomerReplacedSubscriptions from "./customers/replaced_subscriptions.vue";

import ChangeLogsIndex from "./change_logs/index.vue";
import ChangeLogsList from "./change_logs/list.vue";
import ChangeLogsFilters from "./change_logs/filters.vue";

import SubscriptionForm from "./customers/subscription_form.vue";
import Invoices from "./invoices/index.vue";
import InvoiceFilters from "./invoices/filters.vue";
import InvoiceCreditingStatus from "./invoices/crediting-status.vue";
import InvoicesTable from "./invoices/table.vue";
import InvoicesDetailsModal from "./invoices/details-modal.vue";

import Users from "./users/users.vue";
import UserGroups from "./user_groups/index.vue";
import UserGroupEdit from "./user_groups/edit.vue";

import WithActions from "./with-actions.vue";
import StepNavigation from "./_webshipper/step-navigation.vue";
import Carousel from "./_webshipper/carousel.vue";
import Collapsible from "./_webshipper/collapsible.vue";
import InlineRadio from "./_webshipper/inline-radio.vue";
import { SweetModal, SweetModalTab } from "sweet-modal-vue";
import UserModal from "./users/user.vue";

import CustomerNoteModal from "./customer_notes/customer_note.vue";
import CustomerPreviewInvoiceModal from './customers/show/customer-preview-invoice-modal.vue'
import CustomerCreateDiscountModal from './customers/show/customer-create-discount-modal.vue'

import MailTemplatesCreate from "./mail_templates/create.vue";
import MailTemplatesEdit from "./mail_templates/edit.vue";
import MailTemplatesEditor from "./mail_templates/editor.vue";
import MailTemplatesImagesModal from "./mail_templates/images_modal.vue";
import MailTemplatesIndex from "./mail_templates/index.vue";
import MailTemplatesPreviewModal from "./mail_templates/preview_modal.vue";
import MailTemplatesSelector from "./mail_templates/selector.vue";

import WebshipperInputString from "./_webshipper/input/string.vue";
import WebshipperInputText from "./_webshipper/input/text.vue";
import WebshipperInputRadio from "./_webshipper/input/radio.vue";
import WebshipperInputRadioSeperated from "./_webshipper/input/radio-seperated";
import WebshipperInput_Label from "./_webshipper/input/_label.vue";
import WebshipperInput_Revert from "./_webshipper/input/_revert.vue";

import MailBuildersIndex from "./mail_builders/index.vue";
import MailBuildersEdit from "./mail_builders/edit.vue";
import MailBuildersFormEdit from "./mail_builders/form/edit.vue";
import MailBuildersFormGeneral from "./mail_builders/form/general.vue";
import MailBuildersFormAttributes from "./mail_builders/form/attributes.vue";
import MailBuildersFormLocales from "./mail_builders/form/locales.vue";

import MailBuildersModuleNewAttributeModal from "./mail_builders/module/new-attribute-modal.vue";
import MailBuildersModuleAttribute from "./mail_builders/module/attribute.vue";
import MailBuildersModuleLocale from "./mail_builders/module/locale.vue";

import LoadingSpinner from "./loading-spinner.vue";
import NoResult from "./no-result.vue";

import StaffIndex from "./staffs/index.vue";
import StaffForm from "./staffs/form.vue";
import StaffCreate from "./staffs/create.vue";
import StaffEdit from "./staffs/edit.vue";

import BarcodeRangeIndex from "./barcode_ranges/index.vue";
import BarcodeRangeEdit from "./barcode_ranges/edit.vue";
import BarcodeRangeCreate from "./barcode_ranges/create.vue";

import OauthApplicationIndex from "./oauth_applications/index.vue";
import OauthApplicationEdit from "./oauth_applications/edit.vue";
import OauthApplicationCreate from "./oauth_applications/create.vue";
import OnboardingStatus from "./onboarding-status.vue";

import InvoiceForm from "./customers/invoice_form.vue";
import PaymentForm from "./customers/payment_form.vue";

import AutomationsForm from "./automations/_form.vue";
import AutomationsCreate from "./automations/create.vue";
import AutomationsIndex from "./automations/index.vue";
import AutomationsUpdate from "./automations/update.vue";

import ErrorsIndex from "./errors/index.vue";
import ZipcodesIndex from "./zipcodes/index.vue";

import FileUploadCollapsed from "./file-upload-collapsed.vue";
import VueAceEditor from "vue2-ace-editor";

import LazyTable from "./lazy-table.vue";
import SortableTh from "./sortable-th.vue";

import Overlay from "./overlay.vue";
import DatetimePicker from "./datetime-picker.vue";

import CheckBox from "./checkbox.vue";

import CapabilitiesIndex from "./capabilities/index.vue";
import CustomerSpecificServicesModal from "./capabilities/customer_specific_services_modal.vue";
import AddCapabilityModal from "./capabilities/add_capability_modal.vue";

import WhiteLabelReportsIndex from "./white_label_reports/index.vue";

export default {
  "vue-ace-editor": VueAceEditor,
  "file-upload-collapsed": FileUploadCollapsed,
  "lazy-table": LazyTable,
  "sortable-th": SortableTh,
  "datetime-picker": DatetimePicker,
  overlay: Overlay,
  "payment-form": PaymentForm,
  "invoice-form": InvoiceForm,
  invoices: Invoices,
  "invoice-filters": InvoiceFilters,
  "invoice-crediting-status": InvoiceCreditingStatus,
  "invoices-table": InvoicesTable,
  "invoices-details-modal": InvoicesDetailsModal,
  plans: Plans,
  plan: Plan,
  "plans-features-table": PlansFeaturesTable,
  products: Products,
  product: Product,
  "barcode-range-edit": BarcodeRangeEdit,
  "barcode-range-create": BarcodeRangeCreate,
  "barcode-ranges-index": BarcodeRangeIndex,
  authentication: Authentication,
  app: App,
  "address-details": AddressDetails,
  "no-result": NoResult,
  "loading-spinner": LoadingSpinner,
  "payment-terms": PaymentTerms,

  "mail-templates-create": MailTemplatesCreate,
  "mail-templates-edit": MailTemplatesEdit,
  "mail-templates-editor": MailTemplatesEditor,
  "mail-templates-images-modal": MailTemplatesImagesModal,
  "mail-templates-index": MailTemplatesIndex,
  "mail-templates-preview-modal": MailTemplatesPreviewModal,
  "mail-templates-selector": MailTemplatesSelector,

  "mail-builders-index": MailBuildersIndex,
  "mail-builders-edit": MailBuildersEdit,
  "mail-builders-form-edit": MailBuildersFormEdit,
  "mail-builders-form-general": MailBuildersFormGeneral,
  "mail-builders-form-attributes": MailBuildersFormAttributes,
  "mail-builders-form-locales": MailBuildersFormLocales,

  "mail-builders-module-new-attribute-modal":
    MailBuildersModuleNewAttributeModal,
  "mail-builders-module-attribute": MailBuildersModuleAttribute,
  "mail-builders-module-locale": MailBuildersModuleLocale,

  "webshipper-input-string": WebshipperInputString,
  "webshipper-input-text": WebshipperInputText,
  "webshipper-input-radio": WebshipperInputRadio,
  "webshipper-input-radio-seperated": WebshipperInputRadioSeperated,
  "webshipper-input-label": WebshipperInput_Label,
  "webshipper-input-revert": WebshipperInput_Revert,

  "staff-index": StaffIndex,
  "staff-form": StaffForm,
  "staff-edit": StaffEdit,
  "staff-create": StaffCreate,

  "organization-index": OrganizationIndex,
  "organization-edit": OrganizationEdit,
  "organization-form": OrganizationForm,
  "organization-create": OrganizationCreate,

  "customer-index": CustomerIndex,
  "customer-create": CustomerCreate,
  "customer-show": CustomerShow,
  "customer-show-customer-quote-quicklink": CustomerShowCustomerQuoteQuicklink,
  "customer-show-customer-info-agents-card": CustomerShowCustomerAgentsCard,
  "customer-show-customer-info-summary-card": CustomerShowCustomerInfoSummaryCard,
  "customer-show-customer-tab-payments": CustomerShowCustomerTabPayments,
  "customer-show-customer-info-card": CustomerShowCustomerInfoCard,
  "customer-show-customer-info-admin-card": CustomerShowCustomerInfoAdminCard,
  "customer-show-customer-info-billing-card": CustomerShowCustomerInfoBillingCard,
  "customer-show-customer-info-organization-card": CustomerShowCustomerInfoOrganizationCard,
  "customer-show-customer-info-archive-card": CustomerShowCustomerInfoArchiveCard,
  "customer-show-discount-info-card": CustomerShowDiscountInfoCard,
  "customer-show-customer-tab": CustomerShowCustomerTab,
  "customer-show-customer-header-tab": CustomerShowCustomerHeaderTab,
  "customer-show-customer-header-routing": CustomerShowCustomerHeaderRouting,
  "customer-show-customer-info-notes-card": CustomerShowCustomerInfoNotesCard,
  "customer-show-customer-info-installation-note-card": CustomerShowCustomerInfoInstallationNoteCard,
  "customer-form": CustomerForm,
  "customer-edit": CustomerEdit,
  "customer-reset": CustomerReset,
  "customer-impersonate": CustomerImpersonate,
  "customer-filters": CustomerFilters,
  "customer-filters-whitelabel": CustomerFiltersWhiteLabel,
  "customer-events": CustomerEvents,
  "customer-agent-form": CustomerAgentForm,
  "customer-vat-status": CustomerVatStatus,
  "customer-shipment-usage": CustomerShipmentUsage,
  "customer-projected-usage": CustomerProjectedUsage,
  "customer-plans": CustomerPlans,
  "customer-change-logs": CustomerChangeLogs,
  "customer-purchases": CustomerPurchases,
  "customer-new-purchase-form": CustomerNewPurchaseForm,
  "customer-staff-accesses": CustomerStaffAccesses,
  "customer-staff-access-form": CustomerStaffAccessForm,
  "customer-staff-complete-modal": CustomerStaffAccessCompleteModal,
  "customer-creation-form": CustomerCreationForm,
  "customer-creation-company": CustomerCreationCompany,
  "customer-creation-video": CustomerCreationVideo,
  "customer-creation-integrations": CustomerCreationIntegrations,
  "customer-creation-quote": CustomerCreationQuote,
  "customer-replaced-subscriptions": CustomerReplacedSubscriptions,

  "change-logs-index": ChangeLogsIndex,
  "change-logs-list": ChangeLogsList,
  "change-logs-filters": ChangeLogsFilters,
  "with-actions": WithActions,
  "step-navigation": StepNavigation,
  carousel: Carousel,
  collapsible: Collapsible,
  "inline-radio": InlineRadio,
  "address-form": AddressForm,
  "local-attrs": LocalAttrs,
  "local-attr": LocalAttr,
  "sweet-modal": SweetModal,
  "sweet-modal-tab": SweetModalTab,
  "global-attrs": GlobalAttrs,
  "address-validation-validators": AddressValidationValidators,
  "address-validation-filters": AddressValidationFilters,
  "subscription-form": SubscriptionForm,

  "order-channel-index": OrderChannelIndex,
  "order-channel-filters": OrderChannelFilters,

  "carrier-index": CarrierIndex,

  "impersonate-button": ImpersonateButton,

  "order-channel-type-form": OrderChannelTypeForm,
  "order-channel-type-edit": OrderChannelTypeEdit,
  "order-channel-type-index": OrderChannelTypeIndex,
  "order-channel-type-create": OrderChannelTypeCreate,

  "carrier-type-form": CarrierTypeForm,
  "carrier-type-edit": CarrierTypeEdit,
  "carrier-type-index": CarrierTypeIndex,
  "carrier-type-create": CarrierTypeCreate,

  "user-index": Users,
  "user-modal": UserModal,

  "user-groups": UserGroups,
  "user-group-edit": UserGroupEdit,

  "customer-note-modal": CustomerNoteModal,
  "customer-preview-invoice-modal": CustomerPreviewInvoiceModal,
  "customer-create-discount-modal": CustomerCreateDiscountModal,

  "oauth-applications-index": OauthApplicationIndex,
  "oauth-application-edit": OauthApplicationEdit,
  "oauth-application-create": OauthApplicationCreate,
  "onboarding-status": OnboardingStatus,
  "automations-form": AutomationsForm,
  "automations-create": AutomationsCreate,
  "automations-index": AutomationsIndex,
  "automations-update": AutomationsUpdate,

  "errors-index": ErrorsIndex,
  "zipcodes-index": ZipcodesIndex,

  checkbox: CheckBox,

  "capabilities-index": CapabilitiesIndex,
  "capabilities-customer-specific-services-modal":
    CustomerSpecificServicesModal,
  "capabilities-add-cabalitity-modal": AddCapabilityModal,

  "white-label-reports-index": WhiteLabelReportsIndex,
};
